import $ from 'jquery';
import { Component } from 'react';
import { DateTime } from 'common/utils/date';

class CoachingSessionLogClass extends Component {
  constructor(props) {
    super();
    this.state = {
      loading: true,
      error: false,
      page: 1,
      sessions: [],
      sessionCount: '',
      columns: [
        {
          name: 'Day',
          render: session =>
            DateTime.fromISO(session.sharedAt).toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY),
        },
        {
          name: 'Time',
          render: session =>
            DateTime.fromISO(session.sharedAt).toLocaleString(DateTime.TIME_SIMPLE),
        },
        {
          name: 'Title',
          render: session => <span data-notranslate>{session.title}</span>,
        },
        {
          name: 'Coach',
          render: session => <span data-notranslate>{session.coach}</span>,
        },
        {
          name: 'Actions',
          render: session => {
            if (!session.closedTakeaways && !session.openTakeaways) return '';
            return (
              <span>
                {session.openTakeaways} Open
                <br />
                {session.closedTakeaways} Closed
              </span>
            );
          },
        },
      ],
    };
    this.getCoachingSessions = this.getCoachingSessions.bind(this);
  }

  componentDidMount() {
    this.getCoachingSessions();
  }

  getCoachingSessions() {
    this.setState({ loading: true, error: false });
    const { page } = this.state;
    const { employeeId } = this.props.data;
    $.ajax({
      url: `/api/v1/coaching/coaching_session/?page=${page}&employee_id=${employeeId}`,
      dataType: 'json',
      cache: false,
      success: function (response) {
        this.setState({ ...response, loading: false });
      }.bind(this),
      error: function () {
        this.setState({ loading: false, error: true });
      }.bind(this),
    });
  }

  pageLimitReached(page) {
    return page > this.state.totalPages || page === 0;
  }

  setPageAndGet(increment) {
    let page;
    if (increment) {
      page = this.state.page + 1;
    } else {
      page = this.state.page - 1;
    }

    if (!this.pageLimitReached(page)) {
      this.setState({ page }, this.getCoachingSessions);
    }
  }

  render() {
    const { columns, sessions, sessionCount, loading, page, totalPages } =
      this.state;
    const { ableToCoach } = this.props.data;

    return (
      <div className="flexTable coaching-session-log">
        <div className="widgetRow widgetHeader">
          {columns.map((label, index) => (
            <div className="widgetCell" key={`cell-${index}`}>
              {label.name}
            </div>
          ))}
        </div>
        {sessions ? (
          sessions.map((session, index) => (
            <a
              className="widgetRow"
              href={`/one_on_ones/${session.id}`}
              target="_blank"
              rel="noopener noreferrer"
              key={`row-${index}`}
            >
              {columns.map((column, index) => (
                <div className="widgetCell" key={`cell-${index}`}>
                  {column.render(session)}
                </div>
              ))}
            </a>
          ))
        ) : (
          <span className="widgetRow"></span>
        )}
        <div className="session-log-session-actions">
          {ableToCoach && (
            <a
              className="new-session"
              href={`/one_on_ones?employee_id=${this.props.data.employeeId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-edit" />
              View sessions
            </a>
          )}
          {sessionCount > 1 && (
            <div className="pager-actions">
              <span className="session-count">{sessionCount} Sessions</span>
              <button
                className="pager-action"
                onClick={() => this.setPageAndGet(false)}
              >
                <i className="fa fa-chevron-left" />
              </button>
              <span className="pager-status">
                {loading ? (
                  <i className="fa fa-sync-alt fa-spin" />
                ) : (
                  <span>
                    {page} / {totalPages}
                  </span>
                )}
              </span>
              <button
                className="pager-action"
                onClick={() => this.setPageAndGet(true)}
              >
                <i className="fa fa-chevron-right" />
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CoachingSessionLogClass;
